import { toLower } from 'ramda';
import getUrlParamsToLower from './getUrlParamsToLower';
/**
 * Check if a parameter exists in the current URL
 * @param {String} key
 * @returns {Boolean}
 */
const urlHasParam = (key) => {
    const params = getUrlParamsToLower();
    return typeof params[toLower(key)] !== 'undefined';
};
export default urlHasParam;
//# sourceMappingURL=urlHasParam.js.map